import * as React from 'react';
import * as ReactDom from 'react-dom';
import { Link, RouteComponentProps } from 'react-router-dom';
import * as Exceljs from '../../actions/ExportToExcel.js';
import { EmailControl } from './../sharedcomponents/EmailControl';
import { PopupWindow } from './../sharedcomponents/PopupWindow';
import { ExportToExcel } from './../sharedcomponents/ExportToExcel';
import { RCUtils } from '../../RCUtils';
import Workbook from 'react-excel-workbook';
import $ from 'jquery';
var Config: any = require('../../Config.json');
var Excel = Exceljs.default;

interface VCCheckBoxData {
    enableVCCheckBox: boolean;
    disableVCCheckBoxOption: boolean;
    disableVCDropDown: boolean;
    disableVCOption: boolean;
    selectedVCData: server.VesselInformation;
    dropDownVCData: server.VesselInformation[];
    isVCMessage: boolean;
}
const emptyVCCheckBoxData: VCCheckBoxData = { enableVCCheckBox: false, disableVCCheckBoxOption: false, disableVCDropDown: false, disableVCOption: false, selectedVCData: null, dropDownVCData: [], isVCMessage: false };

export interface ToolBarState {   
    exportFields: ExportFields;
    DisableVCOption: boolean;
    EnableVCCheckBox: boolean;
    DisableVCCheckBoxOption: boolean;
    DisableVCDropDown: boolean;
    DropDownVCData: server.VesselInformation[];
    SelectedVCData: server.VesselInformation; 
    VCCheckBoxInfo: VCCheckBoxData;
    SelectedVesselId: number;
    excelData: any[];
    headerData: any[];
    isDownload: boolean;
    excelGridData: any[];
    formName: string;
    fileTitle: string;
    sheetInfo: any;
}
class ExportFields {
    ExportData: string;
}

var self;
const emptyExportFields: ExportFields = { ExportData: '' };

export class GridToolBarPopups extends React.Component<any, ToolBarState> {
    constructor(props: any) {
        super(props);
        this.state = {
            exportFields: emptyExportFields,
            DisableVCOption: false,
            DisableVCCheckBoxOption: false,
            EnableVCCheckBox: false,
            DisableVCDropDown: false,
            DropDownVCData: [],
            SelectedVCData: null,
            VCCheckBoxInfo: emptyVCCheckBoxData,
            SelectedVesselId: 0,
            excelData: [],
            headerData: [],
            isDownload: false,
            excelGridData: this.props.gridData,
            formName: this.props.formName,
            fileTitle: this.props.formName, sheetInfo: ''
        };

        self = this;
    } 

    componentDidMount() {
        this.renderSheets();
    }
   
    componentWillReceiveProps(nextProps: any) {
        if (nextProps.VCCheckBoxInfo != null && nextProps.VCCheckBoxInfo != undefined) {
            this.setState({
                DisableVCOption: nextProps.VCCheckBoxInfo.disableVCOption,
                EnableVCCheckBox: nextProps.VCCheckBoxInfo.enableVCCheckBox,
                DisableVCCheckBoxOption: nextProps.VCCheckBoxInfo.disableVCCheckBoxOption,
                DisableVCDropDown: nextProps.VCCheckBoxInfo.disableVCDropDown,
                DropDownVCData: nextProps.VCCheckBoxInfo.dropDownVCData,
                SelectedVCData: nextProps.VCCheckBoxInfo.selectedVCData,
                VCCheckBoxInfo: nextProps.VCCheckBoxInfo
            });
            if (nextProps.VCCheckBoxInfo.selectedVCData != null) {
                var selectedData = nextProps.VCCheckBoxInfo.selectedVCData;
                this.setState({
                    SelectedVesselId: selectedData.VesselId
                });
            }
            else {
                this.setState({
                    SelectedVesselId: 0
                });
            }
        }
    }
    
    RefreshData() {
        this.props.refreshGrid();
    }

    ExportToExcel() {
        var arrData;
        if (self.props.gridData != undefined && self.props.gridData != null && self.props.gridData .length > 0) {
            arrData = typeof self.props.gridData != 'object' ? JSON.parse(self.props.gridData) : self.props.gridData;
            var r = self.props.colDefs;
            var uri;
            var sheetData = { HeaderData: [], ColumnData: [] };
            $("#globalLoader").show();
            if (self.props.parentchild == 'P') {
                uri = Excel.InitializeExportParentToXLSX(arrData, r, this.props.formName);
                self.state.exportFields.ExportData = JSON.stringify(uri);                
            } else {
                uri = Excel.InitializeExportChildToXLSX(arrData, r, this.props.formName);
                self.state.exportFields.ExportData = JSON.stringify(uri);                
            }

            sheetData = Excel.ConvertCSVToJSon(uri);
            self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(self.props.formName, true));
        }
        else {
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "No Data to Export.");
        }
    }

    closepopupModel() {
        $('#PopupEmailTo').hide();
    }

    EmailTo() {
        $('#PopupEmailTo').show();
    }
    
    IsVCCheckChange(event: React.FormEvent<HTMLInputElement>) {
        var IsCheck: boolean = event.currentTarget.checked;
        this.setState({
            EnableVCCheckBox: IsCheck
        });
        if (event.currentTarget.checked)
            this.setState({ DisableVCDropDown: false });
        else
            this.setState({ DisableVCDropDown: true });
        var checkBoxInfo = this.state.VCCheckBoxInfo;
        checkBoxInfo.enableVCCheckBox = IsCheck;
        checkBoxInfo.disableVCDropDown = (event.currentTarget.checked) ? false : true;
        this.setState({
            VCCheckBoxInfo: checkBoxInfo
        });
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(checkBoxInfo);
    }

    VesselConfigChange(event: React.FormEvent<HTMLSelectElement>) {
        var vesselConfig: string = event.currentTarget.value;       
        var index = event.currentTarget.selectedIndex;
        //var vesselName: string = event.currentTarget[index].text;
        var checkBoxInfo = this.state.VCCheckBoxInfo;
        var selected;
        if (vesselConfig == "0") {
            selected = null;
            checkBoxInfo.selectedVCData = selected;            
        }
        else {
            selected = this.state.DropDownVCData.find(t => t.VesselId == parseInt(vesselConfig));
            checkBoxInfo.selectedVCData = selected
        }
        this.setState({
            SelectedVCData: selected, VCCheckBoxInfo: checkBoxInfo, SelectedVesselId: parseInt(vesselConfig)
        });
        if (this.props.UpdateVCCheckBoxInfo != null && this.props.UpdateVCCheckBoxInfo != 'undefined')
            this.props.UpdateVCCheckBoxInfo(checkBoxInfo);
    }

    renderSheets() {
        this.setState({ sheetInfo: this.generateSheetInfo() }, () => this.checkToFileDownload());
    }

    checkToFileDownload() {
        if (this.state.isDownload) {
            $('#btnDownloadPopUpExcel').click();
            $("#globalLoader").hide();
            PopupWindow.showErrorMessage("Alert", "Data exported successfully.");
            this.setState({ isDownload: false });
        }
    }

    getSheetInfo(headerName: string) {
        var headerInfo = headerName.replace(/\s+/g, '');
        var removeDotInHeader = headerInfo.split('.').join('');
        var removeNInHeader = removeDotInHeader.replace('/n', '');
        var removeHashInHeader = removeNInHeader.replace('#', '');
        var removeUTCInHeader = removeHashInHeader.replace('(UTC)', '');
        var finalHeaderColumn = removeUTCInHeader.replace('(°C)', '');
        return <Workbook.Column label={headerName} value={finalHeaderColumn} />;
    }

    generateSheetInfo() {
        var columnInfo = [];
        if (this.state.headerData != null && this.state.headerData.length > 0) {
            $.each(this.state.headerData, function (i, iVal) {
                var sheetObject = self.getSheetInfo(iVal.headerName);
                columnInfo.push(sheetObject);
            });
        }

        return <Workbook.Sheet data={this.state.excelData} name="Sheet1">
            {columnInfo}
        </Workbook.Sheet>;
    }

    downloadExcel(formName: string, isFileDownload: boolean) {
        var currentDate = new Date();
        self.setState({
            fileTitle: formName + currentDate.getDate() + currentDate.getMonth() + currentDate.getFullYear() + currentDate.getHours() + currentDate.getMinutes() + currentDate.getSeconds(),
            isDownload: isFileDownload
        }, () => self.renderSheets());
    }

    static applySheetData(sheetData: any, formName: string) {
        self.setState({ excelData: sheetData.ColumnData, headerData: sheetData.HeaderData }, () => self.downloadExcel(formName == '' ? self.props.formName : formName, true));
    }

    public render() {
        return <div>
            <div className='aggrid-icons-bg d-flex'>
                <div className="btn-group aggrid-icons">
                    <button type="button" id="RefreshPopUpBtn" title='Refresh' className="btn btn-outline-secondary" onClick={this.RefreshData.bind(this)} ><span className='fas fa-sync-alt'></span></button>
                    <button type="button" id="ExcelPopUpBtn" title='Export to Excel' className="btn btn-outline-secondary" onClick={this.ExportToExcel.bind(this)}><span className='far fa-file-excel'></span></button>
                    <button type="button" id="EmailPopUpBtn" title='Email to' className="btn btn-outline-secondary" onClick={this.EmailTo.bind(this)}><span className='fa fa-envelope'></span></button>
                    <Workbook filename={this.state.fileTitle + ".xlsx"} element={<button id="btnDownloadPopUpExcel" className="btn-lg btn btn-outline-secondary d-none"></button>}>
                        {this.state.sheetInfo}
                    </Workbook>
                </div>               
                <div className='ms-auto d-flex gap-1' hidden={this.state.DisableVCOption}>
                    <div className='form-check trip-label'>
                        <input type="checkbox" className='form-check-input' id='chkSendViaVC' disabled={this.state.DisableVCCheckBoxOption} checked={this.state.EnableVCCheckBox} onChange={e => this.IsVCCheckChange(e)} />
                        <span className='form-check-label align-middle'>Send via VC on Trip Status:</span>
                    </div>
                    <div>
                        <select className='form-select form-select-sm' id='vcOption' disabled={this.state.DisableVCDropDown} onChange={e => this.VesselConfigChange(e)} value={this.state.SelectedVesselId}>
                            <option value="0">--Select--</option>
                            {
                                this.state.DropDownVCData.map((item, index) =>
                                    <option key={index} value={item.VesselId}>{item.VesselNm}</option>
                                )}
                        </select>
                    </div>
                </div>
            </div> 
              <div className="modal" role="dialog" id="PopupEmailTo">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Email</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closepopupModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                          
                        </div>
                        <div className="modal-body">
                            <EmailControl reeferStatusResult={this.props.gridData} columnDefinition={this.props.colDefs} parentchild={this.props.parentchild} formname={this.props.formName} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}